module.exports = __webpack_public_path__ + "static/img/card_tc.85dcff6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store/card_tc.png
// module id = 603
// module chunks = 0